import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from "vue";
import { useApi } from "@/plugins/api/api";
import { Shozoku } from "@/models/transaction/Shozoku";
import { List } from "../UserMasterWorkSchedule";

type Props = {
  list: List[];
};
type Emits = {
  (e: "select", value: List): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleListAddBtn',
  props: {
    list: null
  },
  emits: ["select"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "select", value: List): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  list: List[];
};

const { Paths, $get } = useApi();




const vform = ref();
const isOpen = ref(false);
const items = ref<List[]>([]);
const select = ref<number>();

const required = (val: unknown) => val != null || "入力してください";
const duplicated = (val: unknown) => {
  if (typeof val === "number") {
    const isValid = props.list.every(e => e.value !== val);
    return isValid || "既に登録されています";
  }
  return true;
};

watch(select, newValue => {
  if (!vform.value?.validate()) return;
  if (newValue) {
    const index = items.value.findIndex(e => e.value === select.value);
    emits("select", items.value[index]);
    vform.value?.resetValidation();
    isOpen.value = false;
  }
});

watch(isOpen, () => vform.value?.reset());

const getItems = async () => {
  const result = await $get<Shozoku[]>(Paths.approval.affiliationall);
  if (result) {
    items.value = result.map(e => ({ text: e.sname, value: e.incode }));
  }
};

onMounted(async () => await getItems());

return { __sfc: true,Paths, $get, props, emits, vform, isOpen, items, select, required, duplicated, getItems }
}

})